
import { Vue, Component, Prop } from 'vue-property-decorator'
import { setConnectivityTest } from '@/api/gcash/account'
import { AppModule } from '@/store/modules/app'
import { getSystemNotice } from '@/api/antManage/antManage'

@Component({
  name: 'bulkLogin',
  components: {}
})
export default class extends Vue {
  @Prop({ required: true }) list!: any
  @Prop({ required: true }) code!: any
  @Prop({ required: true }) nameList!: any

  get language() {
    return AppModule.language
  }

  private queryForm: any = {
    product_code: this.code,
    msg: '',
    ant_account: ''
  }
  private btnLoading: boolean = false
  private flag: boolean = false
  private antAccount: any = ''
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }
  private loading: boolean = false
  private back() {
    this.queryForm = {
      product_code: this.code,
      msg: '',
      ant_account: ''
    }
    this.$emit('close')
  }

  private async editorSave() {
    try {
      // this.editAttach()
      this.btnLoading = true
      this.flag = true
      let data: any = {
        // ...this.queryForm
        product_code: this.code,
        msg: this.queryForm.msg,
        ant_account: this.antAccount
      }
      await getSystemNotice(data).then(() => {
        this.$message({
          message: 'Operation is successful!',
          type: 'success'
        })
        this.btnLoading = false
        this.flagStr()
        this.back()
      })
    } catch (e) {
      this.btnLoading = false
      this.flagStr()
    }
  }

  private init() {
    this.queryForm.ant_account = this.nameList.join(', ')
    this.antAccount = this.list.join(', ')
  }

  mounted() {
    this.init()
  }
}
